import { Box, Typography, Toolbar } from "@mui/material";
import { useNavigate } from "react-router";
import { useConfig } from "../../../hooks";
import { styled } from "@mui/material/styles";
import { LanguageMenu } from "./LanguageMenu/LanguageMenu";
import { AppBarLink } from "./AppBarLink";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";

import { useUser } from "../../../context/UserContext";

const StyledBox = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: "100%",
  minWidth: "150px",
  marginLeft: "12px",
  marginRight: "12px",
  "@media (max-width: 945px)": {
    minWidth: "min-content",
    marginLeft: 0,
    marginRight: 0,
  },
}));

const Header = () => {
  const cfg = useConfig();
  const navigate = useNavigate();
  const { logout, user } = useUser();

  const handleSignOut = () => {
    logout();
    window.location.href = '/#/signin';
  };

  return (
    <Toolbar>
      <Box
        display="flex"
        justifyContent="space-between"
        height="100px"
        minWidth="100%"
        padding="0 56px">
        <Box display="flex" alignItems="center">
          <Typography variant="h4" color="inherit" noWrap>
            <span onClick={() => navigate("/")}>
              <img
                src={process.env.PUBLIC_URL + "/pharmadosLogo.png"}
                height={60}
                style={{ verticalAlign: "middle", margin: "2px" }}
                alt="Logo"
              />
            </span>
          </Typography>
        </Box>
        <Box display="flex" height="5rem">
          {
            user.email && (<StyledBox>
              {user.email}
            </StyledBox>)
          }
          <StyledBox>
            <LanguageMenu />
          </StyledBox>
          {
            user.email ? (<StyledBox onClick={handleSignOut}>
              <AppBarLink
                href={cfg.config!.logoutUrl!}
                id="text.logout"
                defaultText="logout"
                icon={<ExitToAppIcon />}
              />
            </StyledBox>) : null
          }

        </Box>
      </Box>
    </Toolbar>
  );
};

export default Header;
